import React, { useEffect, useState } from 'react';
import { makeStyles } from 'tss-react/mui';
import { ICommissionListingData } from '.';
import { IProductionDetailsSummary } from '../../..';
import WidgetPaper from '@components/widgets/display-widget/WidgetPaper';
import WidgetSection from '@components/widgets/display-widget/WidgetSection';
import EnhancedTable from '@components/_old/table/EnhancedTable';
import { IListingData } from '@models/listing';
import {
  capitalizeFirstLetter,
  capitalizeFirstLetterLowerOthers,
} from '@utils/formatting-utils';
import { isValidNumber } from '@utils/validationUtils';
import PrecisionService from '@services/PrecisionService';
import { commissionHeaders } from './content';
const useStyles = makeStyles()(() => ({
  paperClass: {
    boxShadow: 'none !important',
  },
  updateBtn: {
    margin: '15px auto 0',
  },
}));

interface ICommissionSplitWidgetProps {
  data: IProductionDetailsSummary;
}

export const CommissionSplitWidget: React.FC<ICommissionSplitWidgetProps> = ({
  data,
}) => {
  const { classes } = useStyles();

  const [tableData, setTableData] = useState<IListingData<any>>({
    pagedItems: {},
    pageSize: 3,
    pageNumber: 0,
    totalCount: 0,
  });

  useEffect(() => {
    const result: Record<string, ICommissionListingData> = {};
    const newPartnerLov: Record<string, string> = {};

    data.CommissionDetails.forEach((item) => {
      newPartnerLov[item.Id] = item.BusinessUserFullName;

      result[item.Id] = {
        id: item.Id,
        partner: item.BusinessUserFullName,
        share: isValidNumber(item.Share)
          ? PrecisionService.multiplyBy100(Number(item.Share))
          : 0,
        planCommission: item.PlanCommissionAmount,
        applicableOn: capitalizeFirstLetterLowerOthers(item.ApplicableOn, '_'),
        totalAmount: item.PolicyCommisisonAmount,
        isPrimary: item.IsPrimary,
      };
    });

    setTableData({
      pagedItems: result,
      pageSize: data.CommissionDetails?.length | 3,
      pageNumber: 0,
      totalCount: data.CommissionDetails?.length,
    });
  }, [data]);

  return (
    <WidgetPaper>
      <WidgetSection title={capitalizeFirstLetter('Commission Split')}>
        <EnhancedTable
          hideToolbar
          disableSelection
          tableClasses={{
            paperClass: classes.paperClass,
          }}
          usePagination={false}
          name={''}
          inline={true}
          showTablePagination={false}
          headers={commissionHeaders(data?.PolicyCurrency?.Symbol)}
          data={tableData}
        />
      </WidgetSection>
    </WidgetPaper>
  );
};
